import React, { useGlobal, useState, setGlobal } from "reactn"
import { Box, Center, HStack, RadioGroup, SimpleGrid, VStack } from "@chakra-ui/react"
import ColorPicker from "./colorPicker";
import { ZoomImage } from "./imgZoom";
import { chakra, shouldForwardProp } from '@chakra-ui/react';
import { motion, isValidMotionProp } from 'framer-motion';
import ImageAndZoom from "./imageAndZoom";

export const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) => isValidMotionProp(prop) || shouldForwardProp(prop),
});



export function hexToRGB(hexStr) {
  console.log("X2 - HEXSTR", hexStr)
  var col = {};
  col.r = parseInt(hexStr.substr(1, 2), 16);
  col.g = parseInt(hexStr.substr(3, 2), 16);
  col.b = parseInt(hexStr.substr(5, 2), 16);
  return col;
}


// function get_closest_color(colors, [r2, g2, b2]) {
//   const [[closest_color_id]] = (
//     colors
//       .map(([id, r1, g1, b1]) => (
//         [id, Math.sqrt((r2 - r1) ** 2 + (g2 - g1) ** 2 + (b2 - b1) ** 2)]
//       ))
//       .sort(([, d1], [, d2]) => d1 - d2)
//   );
//   return colors.find(([id]) => id == closest_color_id);
// }

function draw() {

  var dArr = [-1, -1, 0, -1, 1, -1, -1, 0, 1, 0, -1, 1, 0, 1, 1, 1], // offset array
    s = 2,  // thickness scale
    i = 0,  // iterator
    x = 5,  // final position
    y = 5;

  // draw images at offsets from the array scaled by s
  for (; i < dArr.length; i += 2)
    ctx.drawImage(img, x + dArr[i] * s, y + dArr[i + 1] * s);

  // fill with color
  ctx.globalCompositeOperation = "source-in";
  ctx.fillStyle = "red";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // draw original image in normal mode
  ctx.globalCompositeOperation = "source-over";
  ctx.drawImage(img, x, y);
}

export async function changeColInUri(data, colours, setError, reverse, isGarment, useWidth) {
  console.log("CHAONGE COLUR", isGarment)
  console.log("X2 - COLS", colours)
  console.log("X2 - DATA", data)
  var rgbCols = {}
  var colorsFromArray = []
  const reversedColours = [
    { from: colours[0].from, to: colours[1].to },
    { from: colours[1].from, to: colours[0].to }
  ]
  console.log("X2 - COLS REV", reversedColours)
  const coloursToProcess = reverse ? reversedColours : colours
  coloursToProcess.forEach(colour => {
    if (colour.to != undefined) {
      console.log("X2 - XXX", colour)
      const rbgFrom = colour.from.rgb
      const rbgTo = colour.to.rgb ? colour.to.rgb : hexToRGB(colour.to)
      // const rbgTo = hexToRGB(colour.to)
      // const rbgFrom = colour.from
      // const rbgTo = colour.to

      colorsFromArray.push([rbgFrom.r, rbgFrom.g, rbgFrom.b])
      rgbCols[String(rbgFrom.r + rbgFrom.g + rbgFrom.b)] = rbgTo
    }
  });

  console.log("X2 - RGB COLS", colorsFromArray)
  try {





    var img = await document.createElement("img");
    img.src = data;
    img.style.visibility = "hidden";
    img.crossOrigin = "Anonymous";
    await img.decode();

    await document.body.appendChild(img);

    var canvas = await document.createElement("canvas");
    console.log("X2 - IMG", img)
    const imageMiltipler = 1
    const scarfWidth = isGarment ? 256 : 80 //TWW TODO
    const scarfHeight = isGarment ? 256 : 998 // 960 
    canvas.width = useWidth ? scarfWidth : (scarfHeight * imageMiltipler) // img.offsetWidth;
    canvas.height = (scarfWidth * imageMiltipler)  //img.offsetHeight;
    console.log("XXSSS", canvas.width, canvas.height)
    var ctx = await canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    // remove image
    img.parentNode.removeChild(img);

    // do actual color replacementx 
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);





    var data = imageData.data;
    var r, g, b;
    // console.log("X2 - DATA FOR LOOP", data.length)
    for (var x = 0, len = data.length; x < len; x += 4) {
      r = data[x];
      g = data[x + 1];
      b = data[x + 2];
      // a = data[x + 3];

      // console.log("X2 - RGB", x, r, g, b)
      const sumRGB = r + g + b

      const rgbTO = rgbCols[String(sumRGB)]
      if (rgbTO) {
        data[x] = rgbTO.r;
        data[x + 1] = rgbTO.g;
        data[x + 2] = rgbTO.b;
      }
    }


    await ctx.putImageData(imageData, 0, 0);

    if (!isGarment) {
      ctx.strokeStyle = coloursToProcess[0].to;
      ctx.lineWidth = 2;
      await ctx.rect(0, 0, canvas.width, canvas.height);
      // await ctx.strokeStyle = 'blue';
      // await ctx.lineWidth(5)
      await ctx.stroke();
    }


    return canvas.toDataURL();
  } catch (e) {
    console.log("X2 - FAILED TO CHANGE IMAGE COLOR", e)
    setError("Failed to change Image color, Please Try Again")
  }
}


const AiDesign = ({ scarf, fetching, globalState, isGarment = true }) => {
  console.log("XXXSCARF", scarf)
  const { store, updateGlobal } = globalState
  const [value, setValue] = React.useState('1')
  const { scarves } = store
  // const [scarves] = useGlobal("scarves")
  const [error, setError] = useState("")

  const selectGarment = (section) => {
    setValue(section)
  }
  const changeColor = async (colours, isGarment, section) => {
    console.log("SECTION", section)
    console.log("X2 - CHANGE COLOR", colours[0])
    console.log("X2 - CHANGE COLOR", colours[1])
    let newImgSrc = scarf.scarfLink
    let newSrcFront = scarf.scarfLink
    let newSrcRear = scarf.scarfLink
    let newSrcGarment1 = scarf.garmentLink1
    let newSrcGarment2 = scarf.garmentLink2
    let newSrcGarment3 = scarf.garmentLink3
    if ( scarf.colourFront == undefined) {
      scarf.colourFront = scarf.scarfLink1
    }
    // if ( scarf.colourRear == undefined) {
    //   scarf.colourRear = scarf.scarfLink1
    // }
    if ( scarf.colourGarment1 == undefined) {
      scarf.colourGarment1 = scarf.garmentLink1
    }
    if ( scarf.colourGarment2 == undefined) {
      scarf.colourGarment2 = scarf.garmentLink2
    }
    if ( scarf.colourGarment3 == undefined) {
      scarf.colourGarment3 = scarf.garmentLink3
    }
    if (!isGarment) {
      newImgSrc = await changeColInUri(scarf.scarfLink, colours, setError, false, isGarment, true)
      newSrcFront = await changeColInUri(scarf.scarfLink, colours, setError, false,  isGarment, false)
      newSrcRear = await changeColInUri(scarf.scarfLink, colours, setError, true,  isGarment, false)
    }
    var scarfOrder = {
      scarves: scarves,
      scarfOrder: {
        prompt: scarf.prompt,                
      }
    }
    
    if (isGarment) {
      if (section == 1) {
        newSrcGarment1 = await changeColInUri(scarf.garmentLink1, colours, setError, false,  isGarment, false)
        scarf.colourGarment1 = newSrcGarment1
        scarfOrder.scarfOrder['garment1']=  newSrcGarment1
      } else if (section == 2) {
        newSrcGarment2 = await changeColInUri(scarf.garmentLink2, colours, setError, false,  isGarment, false)
        scarf.colourGarment2 = newSrcGarment2
        scarfOrder.scarfOrder['garment2']=  newSrcGarment2
      } else if (section == 3) {
        newSrcGarment3 = await changeColInUri(scarf.garmentLink3, colours, setError, false,  isGarment), false
        scarf.colourGarment3 = newSrcGarment3
        scarfOrder.scarfOrder['garment3']=  newSrcGarment3
      }

    }
    
    if (!isGarment) {
      scarf.colourFront = newSrcFront
      scarf.colourRear = newSrcRear
    }

    
     

    if (!isGarment) {
      scarfOrder.scarfOrder['image'] = newImgSrc
      scarfOrder.scarfOrder['scarfFront'] = newSrcFront
      scarfOrder.scarfOrder['scarfRear'] = newSrcRear
    }
    console.log("UPDATEING GLOBAL A", scarfOrder, newImgSrc)
    updateGlobal(scarfOrder)
  }


  return (
    <Box id='desigm' width="100%" marginTop={0}>
      <Box width="100%">
        <Center>
          <VStack width={'100%'} maxW={'1000px'} textAlign={'center'} >
            <VStack width={'100%'}>
              {fetching &&
                <>
                  {!isGarment ?
                    <>

                      <Box w='100%' margin={0} h={'4.3vw'} padding={0} bgColor={'brandWhite.50'}>
                        <Center h={'100%'}>
                          <ChakraBox id="cbox" width='100%' margin={0} padding={0}
                            animate={{
                              opacity: [0, 1],
                            }}
                            transition={{
                              duration: 3,
                              ease: "easeInOut",
                              repeat: Infinity,
                              repeatType: "loop",
                            }}
                            padding="2"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                          >
                            Generating your unique Scarf Design.
                          </ChakraBox>
                        </Center>
                      </Box>
                      <Box w='100%' margin={0} h={'4.3vw'} padding={0} bgColor={'brandWhite.50'}>
                        <Center h={'100%'}>
                          <ChakraBox id="cbox" width='100%' margin={0} padding={0}
                            animate={{
                              opacity: [0, 1],
                            }}
                            transition={{
                              duration: 1,
                              ease: "easeInOut",
                              repeat: Infinity,
                              repeatType: "loop",
                            }}
                            padding="2"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                          >
                            Generating your unique Scarf Design.
                          </ChakraBox>
                        </Center>
                      </Box>
                    </>
                    :
                    <>
                      <Box w='256px' margin={0} h={'256px'} padding={0} bgColor={'brandWhite.50'}>
                        <Center h={'100%'}>
                          <ChakraBox id="cbox" width='100%' margin={0} padding={0}
                            animate={{
                              opacity: [0, 1],
                            }}
                            transition={{
                              duration: 3,
                              ease: "easeInOut",
                              repeat: Infinity,
                              repeatType: "loop",
                            }}
                            padding="2"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                          >
                            This will take up to 30 seconds.
                          </ChakraBox>
                        </Center>
                      </Box>
                    </>
                  }
                </>
              }

              {scarf && (scarf.color || scarf.scarfLink || scarf.garmentLink1) && !fetching &&
                <>
                  <Box width="100%">
                    <Center>
                      <VStack>
                        {scarf.colourFront || scarf.colourGarment1 ?
                          <>
                            {!isGarment ?
                              <>
                                <Box>Front</Box>
                                <ZoomImage zoom={false} src={scarf.colourFront} alt={'Your scarf design front'} hasHeight={false} width="100%" />
                                <Box>Rear</Box>
                                <ZoomImage zoom={false} src={scarf.colourRear} alt={'Your scarf design rear'} hasHeight={false} width="100%" />
                              </>
                              :
                              <SimpleGrid columns={[1, 1  , 3, 3]} width="100%">
                                {/* <RadioGroup onChange={setValue} value={value}> */}
                                <ImageAndZoom scarf={scarf} changeColor={changeColor} select={selectGarment} isGarment={isGarment} section={1} name="Front" value={value}/>
                                <ImageAndZoom scarf={scarf} changeColor={changeColor} select={selectGarment} isGarment={isGarment} section={2} name="Rear" value={value}/>
                                <ImageAndZoom scarf={scarf} changeColor={changeColor} select={selectGarment} isGarment={isGarment} section={3} name="Arm" value={value}/>
                                {/* </RadioGroup> */}
                              </SimpleGrid>
                            }
                          </>
                          :
                          <>
                            {!isGarment ?
                              <>
                                <Box>Front</Box>
                                <ZoomImage zoom={false} src={scarf.scarfLink} alt={'Your scarf design front'} hasHeight={false} width="100%" />
                                <Box>Rear</Box>
                                <ZoomImage zoom={false} src={scarf.orginalReversed} alt={'Your scarf design rear'} hasHeight={false} width="100%" />
                              </>
                              :
                              <SimpleGrid columns={[1, 1, 3, 3]} width="100%">
                                <ImageAndZoom scarf={scarf} changeColor={changeColor} select={selectGarment} isGarment={isGarment} section={1} name="Front" value={value}/>
                                <ImageAndZoom scarf={scarf} changeColor={changeColor} select={selectGarment} isGarment={isGarment} section={2} name="Rear" value={value}/>
                                <ImageAndZoom scarf={scarf} changeColor={changeColor} select={selectGarment} isGarment={isGarment} section={3} name="Arm" value={value}/>
                              </SimpleGrid>
                            }
                          </>
                        }
                      </VStack>
                    </Center>
                  </Box>

                  {scarf.cols &&
                    <Box width={'100%'}>
                      {isGarment &&
                      <Box>
                        Select Image to chage Colour
                      </Box>
                      }
                      <Center>
                        <ColorPicker c1={scarf.cols[0]} c2={scarf.cols[1]}  c3={scarf.cols[2]} changeColor={changeColor} isGarment={isGarment} section={value}/>
                      </Center>
                    </Box>
                  }
                </>
              }
            </VStack>
          </VStack>
        </ Center>
      </Box>
    </Box >
  )
}


export default AiDesign
